import React from 'react';
import { Grid, TextField, Button, InputAdornment } from '@material-ui/core'

import LS from '../../providers/LocalStorage'
import Ws from '../../providers/Ws';
import SpecificComponent from '../../commons/SpecificComponent';
import wallStreet from '../../Pics/wallStreet.jpg'
import ReCAPTCHA from 'react-google-recaptcha';
import SignUp from './SignUp';

export default class LoginExt extends SpecificComponent {
    constructor(props) {
        super(props);
        this.recaptchaRef = React.createRef();
        this.state = {
            u: '',
            p: '',
            verifyCaptcha: false,
            logIn: true,
            mistakenPass: 10
        }
    }



    componentDidMount() {
        this.checkAndLogin()
    }

    

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    checkAndLogin = async () => {

        if (this.props.match.params.usr, this.props.match.params.pass) {
            let WS = new Ws()
            let loginServerResponse = await WS.login(this.props.match.params.usr, this.props.match.params.pass);
            console.log('loginServerResponse = ', loginServerResponse)


            if (this.state.mistakenPass - 1 === 0) {

                this.setState({
                    labRez: this.dictionary.login.parolaGresita,
                    mistakenPass: 1
                }, () => {
                    const timer = setTimeout(() => {
                        this.setState({
                            labRez: '',
                            mistakenPass: 10
                        })
                    }, 90000);

                    return () => clearTimeout(timer);


                })



            } else {
                if (loginServerResponse.Succes) {
                    new LS().SetUserData(loginServerResponse.Content)

                    // console.log('All right simulare save = ')

                    let getUserRights = await WS.customSelect('select u.*, a.id, ad.sef_departament from useri u left join angajati a on u.id = a.id_user left join angajati_departamente ad on ad.id_angajat = a.id where u.id = @p1', {
                        p1: new LS().GetUserData().InfoUser.IdUser
                    })

                    if (getUserRights.Succes) {
                        let obj = new LS().GetUserData();

                        obj.InfoUser.IsAdmin = getUserRights.Content[0].is_admin
                        obj.InfoUser.DrepturiAngajati = getUserRights.Content[0].modifica_angajati
                        obj.InfoUser.AccesProiecte = getUserRights.Content[0].access_proiecte
                        obj.InfoUser.CreazaProiecte = getUserRights.Content[0].creaza_proiecte
                        obj.InfoUser.EsteSef = getUserRights.Content[0].sef_departament
                        obj.InfoUser.AccessFinanciar = getUserRights.Content[0].access_financiar


                        new LS().SetUserData(obj)

                        this.props.history.push('/');
                        document.location.reload();

                    }


                }

                else {
                    this.setState({
                        labRez: loginServerResponse.Messsage,
                        mistakenPass: this.state.mistakenPass - 1
                    })
                }

            }



            // let toSave = {idUser:'777', nume:'Popescu'}

        } else {
            this.setState({ labRez: 'User Sau Parola Gresite' })
        }



    }

    changeCaptcha = async () => {
        console.log('capcha verified :>> ');

        this.setState({ verifyCaptcha: true })
    }


    changeView = () => {
        this.setState({ logIn: this.state.logIn ? false : true })
    }


    render() {
        return (
            <div style={{ marginTop: -80, width: '100%', minHeight: '120vh' }}>

                <div className="pm-login-bg-image" style={{ backgroundImage: `url(${wallStreet})` }} ></div>

                {this.state.logIn &&

                    <Grid container className="loginContainer" style={{ borderRadius: 16, marginBottom: 40, marginTop: '35vh' }} >

                        


                    



                        <span className='pm-warning-validate'>{this.state.labRez}</span>
                      
                          
                        



                    </Grid>

                }






            </div>
        );
    }


}  // end class